import { ActionButton, ICONS, Modal, ModalWidth } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement, useRef } from 'react';
import useFetchUserPermissions from '../../../../../hooks/permissions/useFetchUserPermissions';
import { RpColumn } from '../../../../../models/RpColumn';
import { MonitorDto } from '../../../../../services/dtos/riskProducts/monitor.dto';
import { hasPermissionToExport } from '../../../../../utils/permissionsUtils';
import MonitorActions from '../MonitorActions/MonitorActions';
import MonitorTable, { MonitorTableHandle } from '../MonitorTable/MonitorTable';
import styles from './ExpandedMonitor.module.scss';

const cx = classNames.bind(styles);

interface ExpandedMonitorProps {
  watchListId: string;
  rpColumns: RpColumn[];
  data?: MonitorDto[];
  searchText: string;
  onSearchTextChange: (value: string) => void;
  onClose: () => void;
}

const ExpandedMonitor = ({
  onClose,
  watchListId,
  rpColumns,
  data,
  searchText,
  onSearchTextChange,
}: ExpandedMonitorProps): ReactElement => {
  const { data: userPermissions } = useFetchUserPermissions();
  const monitorTableRef = useRef<MonitorTableHandle | null>(null);

  return (
    <Modal width={ModalWidth.FullScreen} className={cx('body')} onClose={onClose} open>
      <div className={cx('content')}>
        <div className={cx('header')}>
          <div className={cx('heading')}>
            <ActionButton
              icon={ICONS.ArrowLeft}
              onClick={onClose}
              tooltip="Back"
              dataTestId="expanded-table-back-button"
              ariaLabel="back"
            />
            Monitor
            {data && <span className={cx('count')}>{data?.length} entities</span>}
          </div>
          <MonitorActions
            searchText={searchText}
            onSearchTextChange={onSearchTextChange}
            isExportDisabled={!data?.length || !hasPermissionToExport(userPermissions)}
            onExport={monitorTableRef.current?.onExport}
            onManageColumns={monitorTableRef.current?.onManageColumns}
          />
        </div>
        <MonitorTable
          ref={monitorTableRef}
          watchListId={watchListId}
          rpColumns={rpColumns}
          data={data}
          searchText={searchText}
        />
      </div>
    </Modal>
  );
};

export default ExpandedMonitor;
